import React, { useState } from 'react';
import './Menu.css';
import '../styles.css'

const DropdownMenu = ({
  title = 'Título del servicio',
  description = '',
  price = '',
  recomendation = '',
  image,
  whatsappNumber = '5219511035059',
  messageBase = 'Hola, quiero más información sobre el servicio: ',
}) => {
  const [showModal, setShowModal] = useState(false);
  const isVideo = image && image.match(/\.(mp4|webm|ogg)$/i);

  // Mensaje personalizado basado en el título del servicio
  const whatsappMessage = `${messageBase} ${title}`;
  const whatsappLink = `https://api.whatsapp.com/send?phone=${whatsappNumber}&text=${encodeURIComponent(whatsappMessage)}`;

  return (
    <div className="info-section-container">
      <div className="info-layout">
        <div className="info-left">
          <h2>{title}</h2>
        </div>

        <div className="info-right">
          <ul className="price-list">
            <li className="price-item">
              <span className="price-title">Precio:</span>
              <b>
                <span className="price-detail">
                  <p style={{ whiteSpace: 'pre-line' }}>{price}</p>
                </span>
              </b>
            </li>
          </ul>
        </div>
      </div>

      {/* Botón de WhatsApp */}
      <div className="info-buttons">
        <a
          className="button"
          href={whatsappLink}
          target="_blank"
          rel="noopener noreferrer"
        >
          <span>Enviar WhatsApp</span>
        </a>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-button" onClick={() => setShowModal(false)}>✖</button>
            {isVideo ? (
              <video controls className="modal-media">
                <source src={image} type="video/mp4" />
                Tu navegador no soporta el video.
              </video>
            ) : (
              <img src={image} alt="Proceso visual" className="modal-media" />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default DropdownMenu;
